import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TreeModule} from 'primeng/tree';
import { DatepickerComponent } from './datepicker.component';
import {DatepickerService} from '@app/shared/services';

@NgModule({
  imports: [
    CommonModule,
    TreeModule
  ],
  declarations: [DatepickerComponent],
  providers: [DatepickerService],
  exports: [
    DatepickerComponent
  ]
})
export class DatepickerModule { }



// WEBPACK FOOTER //
// ./src/app/datepicker/datepicker.module.ts